import React, { useState } from 'react';
import {
  Box,
  Card,
  CardContent,
  TextField,
  Button,
  Typography,
  IconButton,
  InputAdornment,
  Tabs,
  Tab,
  Paper,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import {
  Lock as LockIcon,
  Visibility,
  VisibilityOff,
  Settings as SettingsIcon,
} from '@mui/icons-material';
import Header from '../components/Layout/Header';
import Sidebar from '../components/Layout/Sidebar';
import ChangePasswordTab from '../components/Forms/ChangePasswordTab';

const Settings = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [sidebarOpen, setSidebarOpen] = useState(!isMobile);
  const [tab, setTab] = useState(0);
  const drawerWidth = 280;

  const handleTabChange = (e, v) => setTab(v);

  return (
    <>
      <Header onMenuClick={() => setSidebarOpen(true)} />
      <Box sx={{ display: 'flex' }}>
        <Sidebar 
          open={sidebarOpen} 
          onClose={() => setSidebarOpen(false)} 
          drawerWidth={drawerWidth} 
        />
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: 0,
            width: { md: `calc(100% - ${drawerWidth}px)` },
            ml: { md: `${0}px` },
            mt: '64px',
            minHeight: 'calc(100vh - 64px)',
            backgroundColor: 'background.default',
          }}
        >
          <Box sx={{ px: 3, pt: 2 }}>
            <Paper elevation={0} sx={{ p: 1, borderRadius: 2, border: 1, borderColor: 'divider', bgcolor: 'background.paper' }}>
              <Tabs
                value={tab}
                onChange={handleTabChange}
                aria-label="Settings Tabs"
                variant="scrollable"
                scrollButtons="auto"
                TabIndicatorProps={{ sx: { height: 3, borderRadius: 2, bgcolor: 'primary.main' } }}
              >
                <Tab 
                  label="Change Password" 
                  sx={{ 
                    textTransform: 'none', 
                    fontWeight: 600, 
                    mr: 1, 
                    borderRadius: 1, 
                    '&.Mui-selected': { color: 'primary.main' } 
                  }} 
                />
              </Tabs>
            </Paper>
          </Box>
          <Box hidden={tab !== 0} role="tabpanel">
            {tab === 0 && (
              <ChangePasswordTab />
            )}
          </Box>
        </Box>
        </Box>
    </>
  );
};

export default Settings;
